<template>
  <vx-card class="mt-base" :title="activityTitle">
    <p class="mb-5">
      Cats and dogs are among some of the more common pets that people keep. They’ve been companion
      animals for humans for many millennia and many breeds would not survive on their own in the
      wild. They make for perfect pets in most cases.
    </p>
    <p class="mb-5">
      However, many people prefer to keep more exotic animals as pets, often these are animals that
      could be classified as wild. Some vets choose to specialise in areas like these. Let’s meet
      one!
    </p>
    <responsive-youtube-wrapper :video="videos[1].url" :image="videos[1].image" />
    <p class="mb-5">
      These animals are usually better off in the wild as they don’t make for good pets or companion
      animals. They often require special attention, care, diet, and housing.
    </p>
    <p class="mb-5">
      Despite this, many people still choose to keep exotic animals as pets, so, as a vet, you’ll
      need to know how best to advise your clients on how to take proper care of some less common
      breeds.
    </p>
    <p class="mb-5">
      To see what an exotic veterinarian in Sydney has to say, and the types of animals he helps and
      why, watch the video below.
    </p>

    <responsive-youtube-wrapper :video="videos[2].url" :image="videos[2].image" />
    <p class="mb-5">
      Now take a look at the following infographic from the British Veterinary Association about
      exotic pets (click the image below to view/download it):
    </p>
    <centered-image-wrapper
      classes="cursor-pointer"
      :image="image1"
      label="View the British Veterinary Association exotic pets infographic: Think Twice, is this pet right for you?"
      @clicked="showIframePopup(popupVideo)"
    />

    <p class="mb-5">
      Once you’ve had a chance to read through the information on each animal, think which animal
      you could best manage as a pet in your current situation and which would be the most difficult
      to manage. Rank each animal from 1 to 6 (with 1 being the most manageable and 6 being the
      least manageable). Record your results in the table below:
    </p>

    <table class="table default-table">
      <tr class="header">
        <th width="50%">Exotic Animal</th>
        <th width="50%">Rank <small>(from 1 to 6)</small></th>
      </tr>
      <tr class="body" v-for="(animal, index) in exotic_animals" :key="index">
        <td>{{ animal }}</td>
        <td><text-block v-model="data['question' + index]" :editable="isEditable" /></td>
      </tr>
    </table>

    <p class="mb-5">
      Can you briefly explain the reasons for your top choice? Record your answer below.
    </p>
    <textarea-block v-model="data.question7" :editable="isEditable" />

    <p class="mb-5">
      <strong>Note:</strong> Keep in mind that many of these animals cannot be kept as pets without
      a permit in Australia. Different states and territories in Australia have different rules
      about buying and having exotic animals as pets!
    </p>
    <p class="mb-5">
      <strong>To learn more:</strong> go to
      <a
        href="https://theconversation.com/heres-what-you-need-to-know-about-exotic-pets-in-australia-79190"
        target="_blank"
        >https://theconversation.com/heres-what-you-need-to-know-about-exotic-pets-in-australia-79190</a
      >
    </p>

    <save-buttons :is-editable="isEditable" @save="save" />
  </vx-card>
</template>

<script>
import methods from '@/views/WorkExperiences/components/activity_js/methods';
import computed from '@/views/WorkExperiences/components/activity_js/computed';
import inject from '@/views/WorkExperiences/components/activity_js/inject';
export default {
  data() {
    return {
      image1: require('@/assets/images/experiences/vet/right_pet_button.jpg'),
      videos: {
        1: {
          image: require('@/assets/images/experiences/vet/wildlife_vet_splash.jpg'),
          url: 'https://www.youtube.com/embed/S7jxL-rTqgI',
        },
        2: {
          image: require('@/assets/images/experiences/vet/sydney_vet_splash.jpg'),
          url: 'https://www.youtube.com/embed/PXY6PnaLvow',
        },
      },
      popupVideo: $vjeConfig.VUE_APP_VJE_PUBLIC_OBJECT_STORAGE_URL + '/content/vet/right_pet.jpg',
      login_type: localStorage.getItem('login_type'),
      exotic_animals: [
        'Ball Python',
        'Leopard Gecko',
        'Bearded Dragon',
        'Degu',
        'Gerbil',
        'Chinchilla',
      ],
    };
  },
  methods: methods,
  computed: computed,
  inject: inject,
};
</script>
